import React from "react";
import { ThemeProvider } from "convertupleads-theme";
import Routes from "./routes/Routes";

function App() {
  return (
    <ThemeProvider>
      <Routes />
    </ThemeProvider>
  );
}

export default App;
